import { useTranslation } from 'react-i18next';
import { AudioGenerationStatus } from '@packages/global';

interface StatusBadgeProps {
  status: AudioGenerationStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation('generation');
  const getStatusStyles = (status: AudioGenerationStatus) => {
    switch (status) {
      case AudioGenerationStatus.COMPLETED:
        return 'bg-success/20 text-success border-success/30';
      case AudioGenerationStatus.PROCESSING:
        return 'bg-info/20 text-info border-info/30';
      case AudioGenerationStatus.FAILED:
        return 'bg-error/20 text-error border-error/30';
      case AudioGenerationStatus.SUBMITTED:
        return 'bg-warning/20 text-warning border-warning/30';
      default:
        return 'bg-bg-elevated text-gray-300 border-border-subtle';
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border backdrop-blur-sm ${getStatusStyles(status)}`}>
      {t(`status.${status}`)}
    </span>
  );
}